import React, { useState } from 'react';
import './instapagostStyle.css';

function PayNowData({amount, paymentInfo, payQr, payType, setPayType}) {
  return (
    <div>
        <div className="text-center mb-4">
            <h5 className="fw-semibold text-dark mb-3" style={{ fontSize: '1rem' }}>Selecciona tu método de pago</h5>
            
            <div className="row justify-content-center g-3">
                <div className="col-md-6">
                    <button 
                        className={`btn w-100 py-3 ${payType === 'mobilePayment' ? 'btn-success' : 'btn-outline-success'}`}
                        onClick={() => setPayType('mobilePayment')}
                        style={{ borderRadius: '12px', border: '2px solid', fontSize: '0.9rem' }}
                    >
                        <i className="fas fa-mobile-alt me-2"></i>
                        <div className="fw-semibold">Pago Móvil</div>
                        <small className="d-block opacity-75">Transferencia por teléfono</small>
                    </button>
                </div>
                {/* <div className="col-md-6">
                    <button 
                        className={`btn w-100 py-3 ${payType === 'transfer' ? 'btn-success' : 'btn-outline-success'}`}
                        onClick={() => setPayType('transfer')}
                        style={{ borderRadius: '12px', border: '2px solid', fontSize: '0.9rem' }}
                    >
                        <i className="fas fa-university me-2"></i>
                        <div className="fw-semibold">Transferencia</div>
                        <small className="d-block opacity-75">Transferencia bancaria</small>
                    </button>
                </div> */}
            </div>
        </div>

        {!payType && (
            <div className="text-center py-5">
                <i className="fas fa-credit-card text-muted" style={{ fontSize: '4rem' }}></i>
                <p className="text-muted mt-3" style={{ fontSize: '0.9rem' }}>Selecciona un método de pago para continuar</p>
            </div>
        )}

        {payType === 'mobilePayment' && (
            <div className="row g-4">
                <div className="col-12">
                    <div className="card border-0 shadow-sm">
                        <div className="card-header bg-primary bg-opacity-10 border-0">
                            <h6 className="mb-0 fw-semibold text-white" style={{ fontSize: '0.9rem' }}>
                                <i className="fas fa-mobile-alt me-2"></i>
                                Información de Pago Móvil
                            </h6>
                        </div>
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                                            <i className="fas fa-university me-2"></i>
                                            Banco
                                        </label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-lg bg-light" 
                                            disabled 
                                            value={`0${paymentInfo.serialNumber} | ${paymentInfo.name}`}
                                            style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                                            <i className="fas fa-phone me-2"></i>
                                            Teléfono
                                        </label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-lg bg-light" 
                                            disabled 
                                            value={paymentInfo.telephone}
                                            style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                                            <i className="fas fa-id-card me-2"></i>
                                            RIF
                                        </label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-lg bg-light" 
                                            disabled 
                                            value={paymentInfo.rif}
                                            style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                                            <i className="fas fa-dollar-sign me-2"></i>
                                            Monto a Pagar
                                        </label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-lg bg-opacity-10 fw-bold text-dark" 
                                            disabled 
                                            value={amount}
                                            style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <div className="text-center mt-4">
                                <div className="card border-0 bg-light">
                                    <div className="card-body p-4">
                                        <h6 className="fw-semibold text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                                            <i className="fas fa-qrcode me-2"></i>
                                            Código QR para Pago
                                        </h6>
                                        <img 
                                            src={payQr?.qrCode} 
                                            alt="Código QR" 
                                            className="img-fluid" 
                                            style={{ maxWidth: '250px', borderRadius: '8px' }}
                                        />
                                        <p className="text-muted small mt-2" style={{ fontSize: '0.8rem' }}>
                                            Escanea este código con tu aplicación bancaria
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}

        {payType === 'transfer' && (
            <div className="row g-4">
                <div className="col-12">
                    <div className="card border-0 shadow-sm">
                        <div className="card-header bg-success bg-opacity-10 border-0">
                            <h6 className="mb-0 fw-semibold text-success" style={{ fontSize: '0.9rem' }}>
                                <i className="fas fa-university me-2"></i>
                                Información de Transferencia
                            </h6>
                        </div>
                        <div className="card-body">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                                            <i className="fas fa-credit-card me-2"></i>
                                            Número de Cuenta
                                        </label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-lg bg-light" 
                                            disabled 
                                            value={paymentInfo.bankAccount}
                                            style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                                            <i className="fas fa-university me-2"></i>
                                            Banco
                                        </label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-lg bg-light" 
                                            disabled 
                                            value={paymentInfo.name}
                                            style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                                            <i className="fas fa-id-card me-2"></i>
                                            RIF
                                        </label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-lg bg-light" 
                                            disabled 
                                            value={paymentInfo.rif}
                                            style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="form-label fw-semibold text-muted mb-2" style={{ fontSize: '0.9rem' }}>
                                            <i className="fas fa-dollar-sign me-2"></i>
                                            Monto a Pagar
                                        </label>
                                        <input 
                                            type="text" 
                                            className="form-control form-control-lg bg-opacity-10 text-dark fw-bold" 
                                            disabled 
                                            value={amount}
                                            style={{ border: '1px solid #e9ecef', borderRadius: '8px', fontSize: '0.9rem' }}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <div className="alert alert-info mt-4" style={{ borderRadius: '8px', fontSize: '0.9rem' }}>
                                <i className="fas fa-info-circle me-2"></i>
                                <strong>Instrucciones:</strong> Realiza la transferencia bancaria con los datos proporcionados y guarda el comprobante para la verificación.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )}
    </div>
  )
}

export default PayNowData